var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PrintShops'),_c('ProductTypes',{staticClass:"mt-6"}),_c('PrintVariants',{staticClass:"mt-6"}),_c('SkuMapping',{staticClass:"mt-6"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }